import { Controller } from "stimulus";

export default class extends Controller {
  initialize() {
    document.addEventListener('turbo:before-fetch-request', this.showProgressBar);
    document.addEventListener('turbo:before-fetch-response', this.changeBrowserUrl)
  }

  showProgressBar(event){
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    const isPrefetchRequest = event.detail.fetchOptions.headers['X-Sec-Purpose'] === 'prefetch'
    if (isPrefetchRequest) return;

    Turbo.navigator.delegate.adapter.formSubmissionStarted(this)
  }

  changeBrowserUrl(event) {
    const response = event.detail.fetchResponse.response
    const isPrefetchRequest = response.headers.get('HTTP_X_SEC_PURPOSE') === 'prefetch'
    const skipHistoryEntry = response.headers.get('HTTP_X_TURBO_SKIP_HISTORY') === 'true'
    const url = new URL(response.url)

    if (!isPrefetchRequest && !skipHistoryEntry && response.ok) {
      history.pushState({ turbo_stream: true }, '', url.href);
    }
    Turbo.navigator.delegate.adapter.formSubmissionFinished(this); // hide loader
  }
}
